// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tirtouga: PokeData = {
  "id": 564,
  "name": "tirtouga",
  "height": 7,
  "weight": 165,
  "base_experience": 71,
  "types": [
    PokeType.WATER,
    PokeType.ROCK
  ],
  "api_moves": [
    "bite",
    "water-gun",
    "hydro-pump",
    "withdraw",
    "bide",
    "rock-slide",
    "curse",
    "protect",
    "rollout",
    "rain-dance",
    "crunch",
    "ancient-power",
    "iron-defense",
    "brine",
    "aqua-tail",
    "aqua-jet",
    "wide-guard",
    "smack-down",
    "shell-smash"
  ],
  "moves": [
    "bite",
    "hydro-pump",
    "rock-slide",
    "curse",
    "protect",
    "rain-dance",
    "crunch",
    "ancient-power",
    "brine",
    "aqua-tail",
    "aqua-jet",
    "aqua-cutter",
    "whirlpool"
  ],
  "evolution_chain": {
    "id": 288,
    "item": null,
    "species": [
      {
        "name": "tirtouga",
        "order": 565,
        "types": [
          PokeType.WATER,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "carracosta",
        "order": 566,
        "types": [
          PokeType.WATER,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 564,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 64,
    "speed": 22,
    "ability_power": 78
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
